// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f3bcad8","borderTopHide":"_72f1f238"};